import type { SearchBarPayload } from "@/features/shop/cms/schemas/searchBarPayload.schema";
import { searchBarPayloadSchema } from "@/features/shop/cms/schemas/searchBarPayload.schema";

const DEFAULT_SEARCH_BAR_PAYLOAD: SearchBarPayload = {
  animation: {
    enabled: true,
    duration: 3.5,
    scale: [1, 1.4, 1],
    opacity: [0.5, 1, 0.5],
    ease: "easeInOut",
  },
  gradientColors: [
    "rgba(124, 58, 237, 1)",
    "rgba(139, 92, 246, 0.95)",
    "rgba(167, 139, 250, 0.9)",
    "rgba(192, 132, 252, 0.85)",
    "rgba(217, 119, 255, 0.75)",
    "rgba(240, 171, 252, 0.6)",
    "rgba(251, 207, 232, 0.4)",
  ],
};

const normalizePayload = (rawPayload: unknown): SearchBarPayload => {
  const validated = searchBarPayloadSchema.parse(rawPayload);
  return validated;
};

export const parseSearchBarPayload = (payloadInput: unknown): SearchBarPayload => {
  if (!payloadInput) {
    return DEFAULT_SEARCH_BAR_PAYLOAD;
  }

  try {
    if (typeof payloadInput === "string") {
      const parsed = JSON.parse(payloadInput);
      return normalizePayload(parsed);
    }

    if (typeof payloadInput === "object") {
      return normalizePayload(payloadInput);
    }

    return DEFAULT_SEARCH_BAR_PAYLOAD;
  }
  catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to parse SearchBar payload, using defaults:", error);
    return DEFAULT_SEARCH_BAR_PAYLOAD;
  }
};
